(function () {
  function initSizeChartDialogs(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-tfk-open-size-chart]').forEach(function (button) {
      if (button.dataset.tfkSizeChartBound === 'true') return;
      button.dataset.tfkSizeChartBound = 'true';
      var dialogId = button.getAttribute('aria-controls');
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;
      var closeButton = dialog.querySelector('[data-tfk-close-size-chart]');
      function closeDialog() {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else { dialog.removeAttribute('open'); dialog.classList.remove('is-fallback-open'); }
        button.focus({ preventScroll: true });
      }
      button.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else { dialog.setAttribute('open', ''); dialog.classList.add('is-fallback-open'); }
      });
      if (closeButton) closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', function () { button.focus({ preventScroll: true }); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && typeof dialog.close !== 'function') closeDialog();
      });
    });
  }
  initSizeChartDialogs(document);
  document.addEventListener('shopify:section:load', function (event) { initSizeChartDialogs(event.target); });
})();
